import type { AssetTransport } from './assetTransport'
import type { NoteAsset } from './assetTypes'
import { APP_SETTINGS } from '../config/appSettings'

/** Use the existing authenticated signer, requesting the master rather than a thumbnail. */
export async function downloadAssetMaster(transport: Pick<AssetTransport, 'getPreviewUrls'>, asset: NoteAsset): Promise<Blob> {
  if (!asset.masterStoragePath) throw new Error('The full image has not synchronized yet. Let the original device finish syncing, then retry.')
  const urls = await transport.getPreviewUrls([{ ...asset, thumbnailStoragePath: null }])
  const url = urls.get(asset.id)
  if (!url) throw new Error('The full image is unavailable. Check your connection and retry.')
  const response = await fetch(url, { signal: AbortSignal.timeout(APP_SETTINGS.images.masterDownloadTimeoutMs) })
  const blob = await response.blob()
  if (!response.ok || !blob.size || blob.size > APP_SETTINGS.images.clientInputSafetyLimitBytes || !blob.type.startsWith('image/')) {
    throw new Error('The full image could not be downloaded. Check your connection and retry.')
  }
  return blob
}
